import { render } from "./HeadView.vue?vue&type=template&id=46698aa8&scoped=true"
import script from "./HeadView.vue?vue&type=script&lang=js"
export * from "./HeadView.vue?vue&type=script&lang=js"

import "./HeadView.vue?vue&type=style&index=0&id=46698aa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46698aa8"]])

export default __exports__